<template>
  <div>
    <!--   课程列表 -->
    <div id="class_list" v-for="item in classItems" :key="item.title">
      <div id="class_li" style="cursor:pointer" @click="toCourseDetail(item.id)">
        <img :src="item.img" alt="" >
        <div>
          <h3 style="text-align:left;margin-top: 5px">{{ item.title }}</h3>
          <p style="text-align:left;margin-top: 5px;opacity: 0.6;font-size: 14px;">{{item.info}}</p>
            <span>
              <el-tag size="mini" style="float:right;margin-right: 5px">{{ item.type }}</el-tag>
            </span>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Message, MessageBox} from "element-ui";
import jwt from 'jsonwebtoken';

export default {
  name: "CourseList",
  props: ['classItems'],
  data() {
    return {
    }
  },
  watch: {
    classData: function (newData, oldData) {
      this.classItems = newData
    }
  },

  methods: {
    //  跳转到详情页面, 根据课程id查询详情页数据
    async toCourseDetail(courseID) {
      // let url = '/courses/detail/' + courseID
      // this.$router.push(url)
      let token = sessionStorage.getItem("token")
      if(!token){
        Message.error("请先登录")
      }else {
        let course_id = courseID;
        const {data: res} = await this.$http.get(`/courses/${course_id}`)
        console.log(res.data)
        if (res.data.length !== 0) {
          let chapter_id = res.data[0].chapter_id;
          let price = res.data[0].price;
          this.toPlayer(course_id, chapter_id,price)

        } else {
          Message.error("课程还未上传视频，请耐心等待")
        }
      }

    },

    // 转跳到播放页
    toPlayer(course_id, chapter_id,price) {
      let token = sessionStorage.getItem("token")
      if(!token){
        Message.error("请先登录")
      }else{
        if(price != 0){
          //查询是否加入课程
          let uid = jwt.decode(token).uid
          this.$http.post(`/users/${uid}/isPurchase/${course_id}`).then(res => {
            if (res.data.data === 0) {
              Message.error("课程还未购买,请联系客服")
            }else{
              this.$router.push('/courses/' + course_id + '/chapter/' + chapter_id)
            }
          })
        }else{
          this.$router.push('/courses/' + course_id + '/chapter/' + chapter_id)
        }
      }
    }
  }
}
</script>

<style scoped>
img {
  width: 100%;
  height: 50%;
  max-height:115px;
  border-radius: 5px 5px 0 0
}

#class_li {
  width: 200px;
  height: 260px;
  background-color: #FFFFFD;
  float: left;
  margin: 20px;
  border-radius: 5px;
  box-shadow: 2px 2px 5px #888888
}
</style>
